import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { CategoryStorePayload, CategoryStoreResponse } from "@/types/interface/category-store";

export const useCategoryStore = defineStore("categoryStore", () => {
  const category = ref<CategoryStoreResponse>();
  const categories = ref<CategoryStoreResponse[]>([]);

  function initCategories(data: any) {
    categories.value = data?.data;
  }

  function addNewCategory(data: any) {
    category.value = data;
  }

  async function dispatchGetCategories(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryStore.getCategoryStore(page, limit, queryParam);
      if (status === 200 ) {
        initCategories(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idCategoryStore = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryStore.findCategoryStore(idCategoryStore);
      if (status === 200 ) {
        addNewCategory(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchCreate(payload: CategoryStorePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryStore.createCategoryStore(payload);
      if (status === 200 ) {
        addNewCategory(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchUpdate(idCategoryStore = "", payload: CategoryStorePayload) : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryStore.updateCategoryStore(idCategoryStore, payload);
      if (status === 200 ) {
        addNewCategory(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDelete(idCategoryStore = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.categoryStore.deleteCategoryStore(idCategoryStore);
      if (status === 200 ) {
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  return {
    category,
    categories,
    initCategories,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchGetCategories,
    dispatchDelete
  };
});